<template>
    <v-container fluid pa-0 v-if="journeyplan && isInJourneyView && total>0">
        <v-row justify="center" class="flex-nowrap">
            <v-col cols="auto">
                <v-row no-gutters>
                    <v-col cols="12">
                        <b>{{title}}</b>
                    </v-col>
                    <v-col cols="12">
                        <v-progress-linear :value="progress"
                                           color="rgba(255,255,255,0.5)"
                                           height="10"
                                           rounded
                                           class="mb-1"
                        ></v-progress-linear>
                    </v-col>
                    <v-col cols="12">
                        <span>{{$tc('general.questions',total)}} {{txtProgress}}</span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="auto" align-self="center" class=" py-0">
                <div style="height: 70px; border: 1px solid rgba(255,255,255,0.6);"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "SurveyProgress",
        computed:{
          txtProgress(){
             if(this.$vuetify.rtl){
               return this.total + '/'+ this.current;
             }else{
               return this.current + '/'+this.total;
             }
          },
          journeyplan(){
            return this.$store.state.assessment.journeyplan;
          },
          current(){
            return this.$store.state.assessment.currentQuestionIndex;
          },
          total(){
            return this.journeyplan.journeyresponses.length;
          },
          progress(){
            return 100*(this.current/this.total);
          },
          title(){
            return this.$ta(this.journeyplan.measure.title_textassetid);
          },
          currentRouteName() {
            return this.$route.name;
          },
          isInJourneyView(){
            return this.currentRouteName==='Journey';
          }
        }
    }
</script>

<style scoped>

</style>